import PAText from "component/design-system/typography/PAText/PAText";
import AffirmLogo from "component/logo/AffirmLogo";
import FlexitiLogo from "component/logo/FlexitiLogo";
import SezzleLogo from "component/logo/SezzleLogo";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import Image from "next/legacy/image";
import { useSelector } from "react-redux";
import isFeatureEnabled from "util/helper/isFeatureEnabled";
import HideIf from "util/HideIf";
import styles from "./column.module.scss";

function Column4(props) {
  const { bnplClass = "" } = props;
  const { t } = useTranslation("common");
  const auth = useSelector((state: RootState) => state.authenticationState);
  const { expConfigurations } = auth;
  const isAffirmEnabled = isFeatureEnabled(expConfigurations, "affirm");

  return (
    <div className={styles.container}>

      <div className={styles.payment_options}>
        {
          ["visa", "mastercard", "amex", "discover", "paypal", "googlepay", "applepay"].map((cardType) => (
            <Image
              src={`https://partsavatar.ca/images/home/${cardType}.webp`}
              alt={`We accept payment via ${cardType}`}
              title={`We accept payment via ${cardType}`}
              width={43}
              height={27}
              unoptimized
              key={cardType}
            />
          ))
        }
      </div>

      <PAText component="p" className={`${styles.pay_later} ${bnplClass} m-t-20`}>{t("Drive Now Pay Later")}</PAText>

      <div className={styles.payment_options}>
        <HideIf show={isAffirmEnabled}>
          <div className={`${styles.bnpl_logo} bnpl-logo`}>
            <AffirmLogo width={59} height={22} />
          </div>
        </HideIf>
        <HideIf show={!isAffirmEnabled}>
          <>
            <div className={`${styles.bnpl_logo} bnpl-logo`}>
              <SezzleLogo />
            </div>
            <div className={`${styles.bnpl_logo} bnpl-logo`}>
              <FlexitiLogo />
            </div>
          </>
        </HideIf>
      </div>
    </div>
  );
}

export default Column4;
